import { useState } from 'react'

import { EMPTY_LIST } from '../../../constants/common'
import { Notifications } from '../../../context'
import { NotificationContainer } from '../NotificationContainer'

function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState(EMPTY_LIST)

  function addNotification(notification) {
    setNotifications(v => [...v, notification])
  }

  function removeNotification(id) {
    setNotifications(v => v.filter(i => i.id !== id))
  }

  return (
    <Notifications
      value={{
        addNotification,
        queue: notifications,
        removeNotification,
      }}
    >
      <NotificationContainer>{children}</NotificationContainer>
    </Notifications>
  )
}

export default NotificationProvider
